import { render, staticRenderFns } from "./CarouselInterval.vue?vue&type=template&id=0a127e26&scoped=true&"
import script from "./CarouselInterval.vue?vue&type=script&lang=js&"
export * from "./CarouselInterval.vue?vue&type=script&lang=js&"
import style0 from "./CarouselInterval.vue?vue&type=style&index=0&id=0a127e26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a127e26",
  null
  
)

export default component.exports